import MobileItemScreen from "./MobileItemScreen.js";
import DesktopItemScreen from "./DesktopItemScreen.js";
import useResponsiveBreakPoints from "../../views/hooks/UseResponsiveBreakpoints.js";
const components = {
  small: MobileItemScreen,
  big: DesktopItemScreen
};
export default function ResponsiveMainScreen(props) {
  return useResponsiveBreakPoints(components, props);
}